/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} User_Sponsored_UnknownInputs */



/**
* | output |
* | --- |
* | "Sponsored on {date}" |
*
* @param {User_Sponsored_UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_sponsored_unknown = /** @type {((inputs: User_Sponsored_UnknownInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Sponsored_UnknownInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Parrainé le ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Avalado el ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Apadrinhado em ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sponsorizzato il ${i?.date}`)
	return /** @type {LocalizedString} */ (`Sponsored on ${i?.date}`)
});